import { useNavigate } from 'react-router-dom';
import { NotFoundError, loadFormDataByUUID } from '@/services';
import { useSearchParamUUID } from '..';
import { useErrorHandler } from '@/hooks';
import { useAppContext } from '@/context';
import { RISK_LIST } from '@/constants';

export const useSearchByUuid = () => {
  const navigate = useNavigate();
  const searchUuid = useSearchParamUUID();
  const { dispatch } = useAppContext();

  const handle = (): void => {
    if (!Boolean(searchUuid)) {
      dispatch({ action: 'risk_load_end' });
      return;
    }

    const errorHandler = useErrorHandler((error) => {
      if (error instanceof NotFoundError) {
        navigate(RISK_LIST);
      }
    });

    dispatch({ action: 'risk_load_start' });

    loadFormDataByUUID(searchUuid)
      .then((payload) => {
        dispatch({ action: 'risk_update_backend_response', payload: structuredClone(payload) });
        dispatch({ action: 'risk_update_data', payload: structuredClone(payload) });
      })
      .catch(errorHandler)
      .finally(() => dispatch({ action: 'risk_load_end' }));
  };

  return { handle };
};
